<template>
	<div class="left-side" v-if="profile.corporateProfile.contact_email || profile.phone || profile.fax_number || profile.address || profile.corporateProfile.website">
		<div class="page-header">
			<h1 class="m-n text-u-c title-font">Contact</h1>
		</div>
		<div class="row">
			<div class="col-lg-12 m-b-md p-x-n" v-if="profile.corporateProfile.contact_email">
				<small class="block text-font">email</small>
				<span class="style-font text-ellipsis">{{ profile.corporateProfile.contact_email }}</span>
			</div>
			<div class="col-lg-12 m-b-md p-x-n" v-if="profile.phone">
				<small class="block text-font">phone</small>
				<span class="style-font text-ellipsis">{{ profile.phone }}</span>
			</div>
			<div class="col-lg-12 m-b-md p-x-n" v-if="profile.fax_number">
				<small class="block text-font">fax</small>
				<span class="style-font text-ellipsis">{{ profile.fax_number }}</span>
			</div>
			<div class="col-lg-12 m-b-md p-x-n" v-if="profile.address">
				<small class="block text-font">address</small>
				<span class="style-font">
					{{ profile.address }}, {{ profile.city }}, {{ getCountryName(profile.country_id) }}
				</span>
			</div>
			<div class="col-lg-12 m-b-md p-x-n" v-if="profile.corporateProfile.website">
				<small class="block text-font text">website</small>
				<a target="_blank" :href="profile.corporateProfile.website" class="text-ellipsis style-font">{{ profile.corporateProfile.website }}</a>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		computed : {
			...mapGetters([
				'profile',
				'getCountryName'
			])
			
		}
	}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 1200px) {
	.left-side .page-header {
		padding-top: 30px;
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 20px;
		line-height: 20px;
		color: #000;
	}
	.text-font {
		font-weight: 300;
		font-size: 13px;
		line-height: 11px;
		color: #888888;
	}
	.style-font {
		font-weight: 300;
		font-size: 13px;
		line-height: 15px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
@media only screen and (max-width: 1199px) and (min-width: 768px) {
	.left-side .page-header {
		padding-top: 30px;
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 18px;
		line-height: 18px;
		color: #000;
	}
	.text-font {
		font-weight: 300;
		font-size: 11px;
		line-height: 11px;
		color: #888888;
	}
	.style-font {
		font-weight: 300;
		font-size: 11px;
		line-height: 15px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
@media only screen and (max-width: 767px) {
	.left-side {
		padding-left: 20px;
	}
	.left-side .page-header {
		padding-top: 30px;
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 20px;
		line-height: 20px;
		color: #000;
	}
	.text-font {
		font-weight: 300;
		font-size: 13px;
		line-height: 11px;
		color: #888888;
	}
	.style-font {
		font-weight: 300;
		font-size: 13px;
		line-height: 15px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
</style>

